import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-underlined-text-button',
  templateUrl: './underlined-text-button.component.html',
  styleUrl: './underlined-text-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnderlinedTextButtonComponent {
  label = input.required<string>();
  ariaLabel = input<string>();
  isDisabled = input<boolean>(false);
  buttonClicked = output<void>();
}
